module.exports = __webpack_public_path__ + "static/media/content-focus.ca6fd444.svg";